import { Injectable } from '@angular/core';
import { ParametroValor } from '@tivic-team/manager-ts/dist/grl';
import { ParametroDTO } from 'app/model/dtos/grl/parametro.dto';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { environment } from 'src/environments/environment';

@Injectable()
export class ParametroController{
    
    constructor() { }
	
    async initParams():Promise<Array<any>>{	
        let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'grl/parametros/initMob',
					environment: environment
				}),
			}),
			new HttpResponse(
				new Array<any>()
			)
        );
        
        return await quark.call();
	}

	async initMob(): Promise<any> {
		let quark = new Quark (
			new HttpPost ({
				url: new Url ({
					id: 'grl/parametros/initMob',
					environment: environment
				}),
			}),
			new HttpResponse(
				new JSONData()
			)
		)

		return await quark.call();
	}

    async getAll():Promise<Array<any>>{	
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/parametros/getAll',
					environment: environment
				}),
			}),
			new HttpResponse(
				new Array<any>()
			)
        );
        
        return await quark.call();
	}

	async getMob():Promise<Array<ParametroDTO>>{	
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/parametros/mob',
					environment: environment
				}),
			}),
			new HttpResponse(
				new Array<any>()
			)
        );
        
        return await quark.call();
	}

	async getNaoCategorizados(categorizados: string[]):Promise<Array<ParametroDTO>>{	
        let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'grl/parametros/mob/nao-categorizados',
					environment: environment
				}),
				data: new JSONData(categorizados)
			}),
			new HttpResponse(
				new Array<any>()
			)
        );
        
        return await quark.call();
	}

	async getOpcoes(nmParametro: string):Promise<Array<ParametroDTO>>{	
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/parametros/mob/:nmParametro',
					pathParams: new JSONData ({nmParametro: nmParametro}),
					environment: environment
				}),
			}),
			new HttpResponse(
				new Array<any>()
			)
        );
        
        return await quark.call();
	}

	async setValores(valores: ParametroValor[]): Promise<any> {
		let quark = new Quark (
			new HttpPut ({
				url: new Url ({
					id: 'grl/parametros/setValores',
					environment: environment,
				}),
				data: new JSONData(valores)
			}),
			new HttpResponse( new JSONData() )
		)

		return await quark.call();
	}

	async getImg(nmParametro: string): Promise<Array<string>> {
		let quark = new Quark (
			new HttpGet ({
				url: new Url ({
					id: 'grl/parametros/mob/:nmParametro/img',
					pathParams: new JSONData ({nmParametro: nmParametro}),
					environment: environment
				})
			}),
			new HttpResponse( new Array<string>())
		)

		return await quark.call();
	}

	async getByNome(nmParametro: string): Promise<ParametroValor> {
		let quark = new Quark (
			new HttpGet({
				url: new Url({
					id: 'grl/parametros/:idParametro/valor',
					pathParams: new JSONData({idParametro: nmParametro}),
					environment: environment
				})
			}),
			new HttpResponse ( new Array())
		)

		return await quark.call();
	}
	
}